var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.diagnoses.length > 0) ? _vm._l((_vm.diagnoses), function(d, index) {
    return _c('div', {
      staticClass: "card-text",
      attrs: {
        "data-testid": 'visit-diagnosis-' + d.id
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('div', {
      staticClass: "p-0"
    }, [_vm._v("\n                    " + _vm._s(d.disease.code) + " - " + _vm._s(d.disease.name_cs) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [_c('i', [_vm._v(_vm._s(d.note))])]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [(d.actions.length < 1) ? [(!_vm.deleteDiagnosisPending) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": 'visit-diagnosis-delete-' + d.id
      },
      on: {
        "click": function($event) {
          _vm.removeDiagnosis(d.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-danger btn-sm disabled"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()], 2)]), _vm._v(" "), _c('list-actions', {
      attrs: {
        "actions": d.actions
      },
      on: {
        "update": _vm.updateDiagnosis,
        "openOperationModal": _vm.openModalWithOperation
      }
    }), _vm._v(" "), ((_vm.diagnoses.length - 1) === index) ? [_c('add-action', {
      attrs: {
        "diagnosisListIndex": index,
        "focus-input": _vm.focusAddActionInput,
        "diagnosis-id": d.id
      },
      on: {
        "focused": _vm.isFocused,
        "update": _vm.updateDiagnosis,
        "openOperationModal": _vm.openModalWithOperation
      }
    })] : [_c('add-action', {
      attrs: {
        "diagnosisListIndex": index,
        "diagnosis-id": d.id
      },
      on: {
        "update": _vm.updateDiagnosis,
        "openOperationModal": _vm.openModalWithOperation
      }
    })], _vm._v(" "), _c('hr', {
      staticClass: "border-primary"
    })], 2)
  }) : (_vm.diagnosesPending) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n        (načítám)\n    ")]) : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n        (žádná diagnóza nebyla přidána)\n    ")]), _vm._v(" "), _c('operation-info', {
    attrs: {
      "operation": _vm.selectedOperation
    }
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a7c86fb","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/ListDiagnosis.vue
// module id = 533
// module chunks = 0